import { defineStore } from "pinia";

export const useEntriesStore = defineStore("entriesStore", {
  state: () => {
    return {
      current: <any>null, // geselecteerde entry
      list: [], // lijst met entries
    };
  },
  getters: {
    fullPath: (state: any) => {
      return state.current?.url.replace("api.", "");
    },
    activeId: (state: any) => {
      return state.current?.id;
    },
    title: (state: any) => {
      return state.current?.title;
    },
    seoTitle: (state: any) => {
      return state.current?.seo?.title;
    },
    seoDescription: (state: any) => {
      return state.current?.seo?.description;
    },
    seoImage: (state: any) => {
      return state.current?.seo?.image;
    },
    blocks: (state: any) => {
      return state.current?.blocks;
    },
    width: (state: any) => {
      return state.current?.width;
    },
    bgColor: (state: any) => {
      return state.current?.bgColor;
    },
    bgGradient: (state: any) => {
      return state.current?.bgGradient;
    },
    textColor: (state: any) => {
      return state.current?.textColor;
    },
  },
  actions: {
    setList(payload: any) {
      this.list = payload;
    },
    setCurrent(payload: any) {
      this.current = payload;
    },
    clearCurrent() {
      this.current = null;
    },
  },
});
